import { render, staticRenderFns } from "./ItemTrainerCard.vue?vue&type=template&id=1c45fb3d&scoped=true&lang=pug&"
import script from "./ItemTrainerCard.vue?vue&type=script&lang=js&"
export * from "./ItemTrainerCard.vue?vue&type=script&lang=js&"
import style0 from "./ItemTrainerCard.vue?vue&type=style&index=0&id=1c45fb3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c45fb3d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
